import { Modal } from 'components';

type Props = {
  children: React.ReactNode;
  onClose: () => void;
};

export const FiltersListModal = ({ children, onClose }: Props) => {
  return (
    <Modal title="" onClose={onClose} type="bottom" hideHeader closeOnBackdrop>
      {children}
    </Modal>
  );
};
